export const modeSearch = {
  change: 'change',
  reset: 'reset',
};

export const locations = [
  {
    id: 'limaCallao',
    label: 'Lima y Callao',
  },
  {
    id: 'provinces',
    label: 'Provincias',
  },
];
